import _ from "lodash";

import Auth from "../../helpers/Authentication/Auth";

export const roles = {
  InternalStandard: "InternalStandard",
  InternalExpert: "InternalExpert",
  ExternalStandard: "ExternalStandard"
};

export const checkIsUserAuthorized = neededRoles => _.some(Auth.getUserRoles(), role => _.includes(neededRoles, role));

export const checkIsExternalUser = () => checkIsUserAuthorized([roles.ExternalStandard]);

export const checkIsInternalUser = () => checkIsUserAuthorized([roles.InternalStandard, roles.InternalExpert]);

export const hasUserAtLeastOneRole = () => checkIsUserAuthorized(_.values(roles));



// WEBPACK FOOTER //
// ./src/helpers/Authorization/authorizationHelpers.js